import { showToast, TYPE_ICON } from './../helpers/sweetAlert.helper';

const wsResponseHandler = (response) => {
  const { estatus, mensaje, datos } = response;
  if (!estatus) {
    showToast('Error', mensaje, TYPE_ICON.ERROR);
    return false;
  }
  return datos;
};

export default wsResponseHandler;
